import { ConvertTenantToCsv, ConvertToCSV } from "@services/ConvertToCSV";
import { GetCurrentDate } from "@services/Utilities";

// retain this temporarily for tenant functionality
export const HandleDownloadCSV = (
  selectedData: any[],
  filename: string,
  headerMapping: Record<string, string>,
  type = "user",
) => {
  let csvContent = "";

  if (type === "tenant") {
    csvContent = ConvertTenantToCsv(selectedData, headerMapping);
  } else {
    csvContent = ConvertToCSV(selectedData, headerMapping);
  }

  const currentDate = GetCurrentDate();

  const utf8WithBom = new Uint8Array([
    0xef,
    0xbb,
    0xbf,
    ...new TextEncoder().encode(csvContent),
  ]);
  const blob = new Blob([utf8WithBom], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `${selectedUserData.length}件の${filename}${currentDate}.csv`,
  );
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const ConvertAndDownloadCSV = (
  fileLength: number,
  csvContent: string,
  filename: string,
) => {
  const currentDate = GetCurrentDate();

  const utf8WithBom = new Uint8Array([
    0xef,
    0xbb,
    0xbf,
    ...new TextEncoder().encode(csvContent),
  ]);
  const blob = new Blob([utf8WithBom], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `${fileLength || ""}件の${filename}${currentDate}.csv`,
  );
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
